import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import styles from './userDropdown.css';
import { baseRoute } from '../../../../../../constants/routes';
import http from '../../../../../../utils/httpService';
import { deleteCookie } from '../../../../../../utils/cookieService';
import Logout from '../../../../../../assets/svg/logout.svg';
import ApiIcon from '../../../../../../assets/svg/document-code.svg';
import SettingsIcon from '../../../../../../assets/svg/setting-2.svg';
import ProtectedComponent from '../../../../../../components/protectedComponent/ProtectedComponent';


/**
 *
 * @type {React.NamedExoticComponent<{readonly content?: *, readonly profile?: *, readonly history?: {push: *}}>}
 */
const UserDropdown = React.memo ( ( { history: { push }, content, profile, apiHandle, showApi } ) => {

    const logOut = () => {
        http.request ( baseRoute + '/logout' );
        deleteCookie ( 'token' );
        deleteCookie ( 'refreshToken' );
        push ( '/login' );
    };


    return (
        <Fragment>
            <div className={ styles.option }>
                <img src={profile.avatar_url} className={ styles.usrImg} alt='avatar'></img>
                <span className={ styles.optionText }>{ profile.name }</span>
            </div>
            <div className={`${styles.option} ${styles.apiSettings}` } >
                <SettingsIcon className={ styles.optionIcon }/>
                <Link
                        to='/settings/profile'
                        className={ styles.logo }
                    >
                    <span className={ styles.optionText }>{ content.settings.profile_settings }</span>
                </Link>
            </div>
            <ProtectedComponent permissions={['api_settings']}>
                <div className={`${styles.option} ${styles.apiSettings}`} onClick={apiHandle} >
                    <ApiIcon className={styles.optionIcon} />
                    <span className={styles.optionText}>{content.api_settings}</span>
                    {/* <ChevronIcon className={showApi ? styles.shevronIconRotate : styles.shevronIcon} /> */}
                </div>
            </ProtectedComponent>
            <div className={ styles.option } onClick={ logOut }>
                <Logout className={ styles.optionIcon }/>
                <span className={ styles.optionText }>{ content.quiz.editor.log_out }</span>
            </div>

        </Fragment>
    );
} );

export default withRouter ( UserDropdown );